<template>
	<div
		class="z-10"
		:class="{
			'position-sticky top-0': sticky,
			'pb-3 pt-4 bg-white w-100': true
		}"
	>
		<div
			class="d-md-flex align-items-end align-items-md-center justify-content-between"
			:class="{ 'text-center': center }"
		>
			<div class="flex-wrap flex-1 d-flex">
				<div
					v-if="image"
					class="flex-shrink-0 mr-3 d-flex align-items-center"
					style="width: 3.2rem; height: 3.2rem;"
				>
					<img :src="image" class="img-fluid rounded-circle" />
				</div>
				<div class="d-flex align-items-center flex-grow-1 min-width-0">
					<div v-if="$slots.left" class="flex-shrink-0 mr-3">
						<slot name="left" />
					</div>
					<div class="flex-grow-1 min-width-0">
						<div class="prehead" v-if="prehead">
							<nuxt-link v-if="preheadUrl" :to="preheadUrl">
								{{ prehead }}
							</nuxt-link>
							<span v-else>
								{{ prehead }}
							</span>
						</div>
						<h1 v-if="title" class="mt-0 heading-title">
							{{ title }}
							<small v-if="postfix" class="font-extrabold">
								{{ postfix }}
							</small>
						</h1>
						<div class="row">
							<div class="col-12">
								<slot name="subtitle" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pt-2 ml-auto d-md-block d-none align-self-start">
				<slot name="actions" />
			</div>
			<div>
				<div class="d-md-none d-block">
					<slot name="actions" />
				</div>
				<slot />
				<nuxt-link v-if="buttonUrl && buttonText" :to="buttonUrl">
					<button class="btn btn-primary">
						{{ buttonText }}
					</button>
				</nuxt-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Heading',
	props: {
		title: {
			type: String,
			default: null
		},
		buttonUrl: {
			type: String,
			default: null
		},
		buttonText: {
			type: String,
			default: null
		},
		postfix: {
			type: [String, Number],
			default: null
		},
		prehead: {
			type: String,
			default: null
		},
		preheadUrl: {
			type: String,
			default: null
		},
		center: {
			type: Boolean,
			default: false
		},
		image: {
			type: String,
			default: null
		},
		sticky: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
.heading-title {
	word-break: break-word;
	overflow-wrap: break-word;
	hyphens: auto;
}

.min-width-0 {
	min-width: 0;
}

/* Mobile responsive font sizing */
@media (max-width: 767.98px) {
	.heading-title {
		font-size: 1.5rem !important;
		line-height: 1.3;
	}

	.prehead {
		font-size: 0.8rem !important;
	}
}

@media (max-width: 575.98px) {
	.heading-title {
		font-size: 1.25rem !important;
		line-height: 1.2;
	}

	.prehead {
		font-size: 0.8rem !important;
	}
}
</style>
